import { HTMLAttributes, useState } from 'react';
import { QuoteTagEnum, usePopover } from '@jove-frontend/uikit';
import { Box, Popover, Typography } from '@mui/material';
import clsx from 'clsx';
import ItemView, { TableFilterCardItemFieldProp } from './item';

type TableFilterCardListCommonViewProps = HTMLAttributes<HTMLDivElement> & {
  titleKey?: string;
  isSelectedKey?: string;
  list: Array<TableFilterCardItemFieldProp>;
  itemChange?: (index: number, item: TableFilterCardItemFieldProp) => void;
  disabled?: boolean;
};

const TableFilterCardListCommonView = (props: TableFilterCardListCommonViewProps) => {
  const { list = [], className, titleKey = 'title', isSelectedKey = 'isSelected', itemChange, disabled } = props;
  const { popoverOpen, popoverAnchorEl, setPopoverOpen, setPopoverAnchorEl } = usePopover();
  const [displayText, setDisplayText] = useState('');

  const openPopoverAction = (event: React.MouseEvent<any>, item) => {
    if ([QuoteTagEnum().switchToJove.value].includes(item.value)) {
      setPopoverOpen(true);
      setPopoverAnchorEl(event.currentTarget);
      setDisplayText('Action required - existing policy expiring within 60 days');
    }
  };
  const closePopoverAction = () => {
    setPopoverOpen(false);
    setPopoverAnchorEl(null);
    setDisplayText('');
  };

  return (
    <div className="flex w-full flex-row overflow-x-auto">
      <div className={clsx('flex flex-row overflow-visible', className)}>
        {list.map((item, index) => {
          return (
            <ItemView
              key={item[titleKey] + index}
              className="min-w-[120px]"
              info={item}
              index={index}
              titleKey={titleKey}
              isSelectedKey={isSelectedKey}
              clickItem={itemChange}
              confirmEdit={itemChange}
              disabled={disabled}
              onMouseEnter={(event) => openPopoverAction(event, item)}
              onMouseLeave={closePopoverAction}
            />
          );
        })}
      </div>
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none' }}
        open={popoverOpen}
        anchorEl={popoverAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={closePopoverAction}
        disableRestoreFocus
      >
        <Box className="max-w-[360px] p-2">
          <Typography variant="subtitle2" className="font-medium">
            {displayText}
          </Typography>
        </Box>
      </Popover>
    </div>
  );
};

export default TableFilterCardListCommonView;
